import { InsightsTabs } from "./InsightsTabs";

export default InsightsTabs;
